// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__27lRK","content":"styles_content__2r1fj","checkbox":"styles_checkbox__1kVZw","checkboxLabel":"styles_checkboxLabel__w-653"};